import { getBaseMetaTitle } from '@/environments'

const ArchiveWinnerCategory = () => import('./Main')

const route = {
  path: '/archive/winner/:year/:categoryName',
  name: 'winnerArchiveCategory',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ArchiveWinnerCategory
}

export default route
